<template>
  <div>
  <myHeader></myHeader>

  <div class="webTarifEnfants webTarifMainBloc">
    <h2>Enfants</h2>
    <div class="webTarifImg webTarifImg2">
      <img src="../../assets/PrestationEnfant2.jpeg" alt="coupe enfant">
    </div>
    <p class="webTarifTitle">Un moment pour vos petits bouts</p>

    <h3 class="webTarifH3Style">Tarifs</h3>
    <div class="webTarifgroup">
      <div class="webTarifEntete">
        <p class="webTarifLines"></p>
        <p></p>
        <p>0 - 5 ans</p>
        <p></p>
        <p>6 - 17 ans</p>
        <p></p>
      </div>
      <div :key="'tarifFiltersKid' + index" v-for="(tarifFiltersKid, index) in tarifFiltersKids">
        <p @click.prevent="editTarif(tarifFiltersKid._id)" type="submit" class="webTarifNames">{{ tarifFiltersKid.name }}
        </p>
        <div class="webTarifLines">
          <p class="webTarifValues"></p>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersKid.priceUnique" type="string" name="priceUnique" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersKid.priceS" type="string" name="priceS" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersKid.priceM" type="string" name="priceM" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersKid.priceL" type="string" name="priceL" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
          v-model="tarifFiltersKid.priceXL" type="string" name="priceXL" class="webTarifValues"
          disabled="disabled"></vue-numeric>
      </div>
    </div>
  </div>
</div>

  <myFooter></myFooter>
  </div>
</template>

<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'
export default {
  components: {
    VueNumeric
  },
  name: 'webTarifEnfants',
  data () {
    return {
      tarif: []
    }
  },
  mounted () {
    this.getAllTarifs()
  },
  computed: {
    tarifFiltersKids () {
      return this.tarif.filter(tarif => tarif.category === 'ENFANTS')
    }
  },
  methods: {
    getAllTarifs () {
      axios
        .get(('https://privilegia.fr/api/tarifs'))
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    }
  }
}
</script>

  <style>
  </style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebTarifsEnfants.vue